import * as React from "react";
import { KeyboardKeyHybrid } from "./KeyboardKeyHybrid";
import type { TypeKeyboardKeyProps } from "./KeyboardKeyTypes";

/**
 * KeyboardKey component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or styled() extension).
 */
export const KeyboardKey = (props: TypeKeyboardKeyProps) => (
  <KeyboardKeyHybrid {...props} />
);
